import React,{ useEffect, useState } from 'react';
import styles from './resend-otp.module.scss';


export function ResendOTP(props) {
  const { time, onSubmit } = props;
  const [currentTime, setCurrentTime] = useState(0);
  const timeInMinutes = Math.floor(currentTime / 60);
  const timeInSeconds = currentTime % 60;

  useEffect(() => {
    const interval = setInterval(() => {
      if (currentTime === 0) {
        clearInterval(interval);
      } else {
        setCurrentTime(currentTime - 1);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [currentTime]);

  const handleSubmit = () => {
    onSubmit();
    setCurrentTime(time);
  };

  return (
    <div className={styles['container']}>
      <div className={styles['resend-otp-msg']}>
        Didn't recieve code ?
        {currentTime ? (
          <span
            className={styles['timer']}
          >{`${timeInMinutes}:${timeInSeconds}`}</span>
        ) : (
          <span className={styles['resend-btn']} onClick={handleSubmit}>
            Send again
          </span>
        )}
      </div>
    </div>
  );
}

export default ResendOTP;
